import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDirectoryGetProductionCalendarQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { RequestOptions } from '../types';

export const useDirectoryGetProductionCalendar = (options?: RequestOptions) => {
  const {
    loading,
    error: apolloError,
    data,
  } = useDirectoryGetProductionCalendarQuery(options);

  const error = useError(apolloError);

  const productionCalendar = useMemo(
    () =>
      data?.productionCalendar
        ? {
            id: data?.productionCalendar?.id || '',
            versionNumber: data?.productionCalendar?.version?.number,
            nonBusinessDays: data?.productionCalendar?.nonBusinessDays || [],
          }
        : undefined,
    [data]
  );

  return {
    loading,
    error,
    productionCalendar,
  };
};
